export const Constants = {
  associated: ' OS atreladas',
  previousWorkOrders: 'Esta matrícula possui ordens de serviço anteriores:',
  createdAt: 'data de criação:',
  evaluatedValue: 'valor avaliado:',
  evaluationType: 'tipo de cálculo:',
  reportType: 'tipo de relatório:',
};
